import _ from "lodash";

export default {
    data() {
        return {
            initialModelData: {
                Vehicle_data: {
                    name: this.$t("details-component.vehicle-data"),
                    value: "subtitle_class",
                    attribID: "",
                },
                Plate_Date: {
                    name: this.$t("details-component.plate-date"),
                    fieldName: "Plate_Date",
                    value: "",
                    attribID: "",
                },
                Build_Year: {
                    name: this.$t("details-component.build-year"),
                    fieldName: "Build_Year",
                    value: "",
                    attribID: "",
                },
                model_data: {
                    name: this.$t("details-component.model-data"),
                    value: "subtitle_class",
                    attribID: "",
                },
                Make: {
                    name: this.$t("details-component.make"),
                    fieldName: "Make",
                    value: "",
                    attribID: "",
                },
                Model: {
                    name: this.$t("details-component.model"),
                    fieldName: "Model",
                    value: "",
                    attribID: "",
                },
                Version: {
                    name: this.$t("details-component.version"),
                    fieldName: "Version",
                    value: "",
                    attribID: "",
                },
                Mark_date: {
                    name: this.$t("details-component.mark-date"),
                    value: "-",
                    attribID: "",
                },
                Color: {
                    name: this.$t("details-component.color"),
                    fieldName: "Color",
                    value: "",
                    attribID: "",
                },
                Gearbox: {
                    name: this.$t("details-component.gearbox"),
                    fieldName: "Gearbox",
                    value: "",
                    attribID: "",
                },
                Drive: {
                    name: this.$t("details-component.drive"),
                    fieldName: "Drive",
                    value: "",
                    attribID: "",
                },
                VIN: {
                    name: this.$t("details-component.vin"),
                    fieldName: "VIN",
                    value: "",
                    attribID: "",
                },
                Mark_From: {
                    name: this.$t("details-component.mark-from"),
                    fieldName: "Mark_From",
                    value: "",
                    attribID: "",
                },
                Mark_To: {
                    name: this.$t("details-component.mark-to"),
                    fieldName: "Mark_To",
                    value: "",
                    attribID: "",
                },
                carrocaria_data: {
                    name: this.$t("details-component.body-group-data"),
                    value: "subtitle_class",
                    attribID: "",
                },
                Veh_Type: {
                    name: this.$t("details-component.vehicle-type"),
                    fieldName: "Veh_Type",
                    value: "",
                    attribID: "",
                },
                BodyGroup: {
                    name: this.$t("details-component.body-group"),
                    fieldName: "BodyGroup",
                    value: "",
                    attribID: "",
                },
                BodyStyleTips: {
                    name: this.$t("details-component.body-style-tips"),
                    fieldName: "BodyStyleTips",
                    value: "",
                    attribID: "",
                },
                Nbr_Doors: {
                    name: this.$t("details-component.nbr-doors"),
                    fieldName: "Nbr_Doors",
                    value: "",
                    attribID: "",
                },
                Nbr_Seats: {
                    name: this.$t("details-component.nbr-seats"),
                    fieldName: "Nbr_Seats",
                    value: "",
                    attribID: "",
                },
                Gross_Weight: {
                    name: this.$t("details-component.gross-weight"),
                    fieldName: "Gross_Weight",
                    value: "",
                    attribID: "",
                },
                motor_data: {
                    name: this.$t("details-component.motor-data"),
                    value: "subtitle_class",
                    attribID: "",
                },
                Fuel_Type: {
                    name: this.$t("details-component.fuel-type"),
                    fieldName: "Fuel_Type",
                    value: "",
                    attribID: "",
                },
                FuelTypeTips: {
                    name: this.$t("details-component.fuel-type-tips"),
                    fieldName: "FuelTypeTips",
                    value: "",
                    attribID: "",
                },
                Cubic_Cap: {
                    name: this.$t("details-component.cubic-cap"),
                    fieldName: "Cubic_Cap",
                    value: "",
                    attribID: "",
                },
                Power_kW: {
                    name: this.$t("details-component.power-kw"),
                    fieldName: "Power_kW",
                    value: "",
                    attribID: "",
                },
                Power_CV: {
                    name: this.$t("details-component.power-cv"),
                    fieldName: "Power_CV",
                    value: "",
                    attribID: "",
                },
                Engine_Code: {
                    name: this.$t("details-component.engine-code"),
                    fieldName: "Engine_Code",
                    value: "",
                    attribID: "",
                },
                CO2: {
                    name: this.$t("details-component.co2"),
                    fieldName: "CO2",
                    value: "",
                    attribID: "",
                },
                tyre_data: {
                    name: this.$t("details-component.tyre-data"),
                    value: "subtitle_class",
                    attribID: "",
                },
                Tire_Front: {
                    name: this.$t("details-component.tyre-front"),
                    fieldName: "Tire_Front",
                    value: "",
                    attribID: "",
                },
                Tire_Rear: {
                    name: this.$t("details-component.tyre-rear"),
                    fieldName: "Tire_Rear",
                    value: "",
                    attribID: "",
                },
            },
        };
    },
    computed: {
        vehicleState() {
            return this.$store.getters["vehicleIdentification/getState"];
        },
        showDetailsComponent() {
            return this.vehicleState.data.length;
        },
        carMake() {
            return this.$helpers.getVehicleAttributeValue(
                this.$globals.ATTRIB_ID.MAKE
            );
        },
        carModel() {
            return this.$helpers.getVehicleAttributeValue(
                this.$globals.ATTRIB_ID.MODEL
            );
        },
        carPlate() {
            return this.vehicleState.plateNumber;
        },
        detailsTitle() {
            let make = this.$helpers.getVehicleAttributeValue(
                this.$globals.ATTRIB_ID.MAKE
            );
            let model = this.$helpers.getVehicleAttributeValue(
                this.$globals.ATTRIB_ID.MODEL
            );
            return `${make} ${model}`;
        },
        vehicleData() {
            let modeldata = _.cloneDeep(this.initialModelData);

            let data = this.vehicleState.processNumber
                ? this.vehicleState.data
                : [];

            data.forEach((item) => {
                if (modeldata.hasOwnProperty(item.description)) {
                    modeldata[item.description].attribID = item.attribID
                    modeldata[item.description].value = [
                        "Plate_Date",
                        "Mark_From",
                        "Mark_To",
                        "Mark_date",
                    ].includes(item.description)
                        ? this.dateFormatter(item.value, item.description)
                        : item.value;
                }
            });

            let listInformations = [];

            for (let item in modeldata) {
                if (
                    (modeldata[item].value != "" &&
                        this.hasTyresData(modeldata, item) &&
                        this.hasRegistryData(modeldata, item)) ||
                    !this.vehicleState.processNumber
                ) {
                    listInformations.push({
                        name: modeldata[item].name,
                        value: modeldata[item].value,
                        attribID: modeldata[item].attribID,
                    });
                }
            }

            const indexMarkTo = listInformations.findIndex(
                (el) => el.name == "Mark_To"
            );
            const indexMarkFrom = listInformations.findIndex(
                (el) => el.name == "Mark_From"
            );

            let makeDate = null;

            if (indexMarkTo > -1 && indexMarkFrom > -1) {
                const martkTo = listInformations[indexMarkTo].value;
                const martkFrom = listInformations[indexMarkFrom].value;

                makeDate = `${martkFrom} a ${martkTo}`;
                if (!martkFrom) {
                    makeDate = martkTo;
                } else if (!martkTo) {
                    makeDate = martkFrom;
                }
                listInformations.splice(indexMarkTo, 1);
                listInformations.splice(indexMarkFrom, 1);
            } else if (indexMarkTo > -1) {
                const martkTo = listInformations[indexMarkTo].value;
                makeDate = `- a ${martkTo}`;
                listInformations.splice(indexMarkTo, 1);
            } else if (indexMarkFrom > -1) {
                const martkFrom = listInformations[indexMarkFrom].value;
                makeDate = `${martkFrom} a -`;

                listInformations.splice(indexMarkFrom, 1);
            }

            if (makeDate) {
                const index_date_m = listInformations.findIndex(
                    (el) => el.name == this.$t("details-component.mark-date")
                );
                listInformations[index_date_m].value = makeDate;

                let lastChar = makeDate.slice(-1);
                if (lastChar == "-") {
                    makeDate = makeDate.substring(0, makeDate.length - 3);
                    listInformations[index_date_m].value = makeDate;
                }
            }

            this.$store.commit(
                "vehicleIdentification/setVehicleIdentificationDetailsData",
                listInformations
            );

            return listInformations;
        },
    },
    methods: {
        dateFormatter(str, format) {
            if (!str) return "";
            str = str.split("");
            return format === "Plate_Date"
                ? `${str[6]}${str[7]}-${str[4]}${str[5]}-${str[0]}${str[1]}${str[2]}${str[3]}`
                : `${str[4]}${str[5]}-${str[0]}${str[1]}${str[2]}${str[3]}`;
        },
        hasTyresData(modeldata, item) {
            return (
                modeldata[item].name !=
                    this.$t("details-component.tyre-data") ||
                (modeldata[item].name ==
                    this.$t("details-component.tyre-data") &&
                    (modeldata["Tire_Front"].value != "" ||
                        modeldata["Tire_Rear"].value != ""))
            );
        },
        hasRegistryData(modeldata, item) {
            return (
                modeldata[item].name !=
                    this.$t("details-component.vehicle-data") ||
                (modeldata[item].name ==
                    this.$t("details-component.vehicle-data") &&
                    (modeldata["Plate_Date"].value != "" ||
                        modeldata["Build_Year"].value != ""))
            );
        },
    },
};
